import { Component, OnInit, OnDestroy, ViewChild, ElementRef, Renderer2 } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Router } from '@angular/router';
import { ClientService, ModalService, PagesService, EmailService, Email, UtilsService } from '../services';
import { I18nPipe } from '../shared/pipes/i18n.pipe';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-email',
  templateUrl: 'email.component.html',
  styleUrls: ['email.component.css'],
  providers: [PagesService, EmailService]
})
export class EmailComponent implements OnInit, OnDestroy {
  page: any;
  roomNumber = '';
  personNumber = '1';
  inputFocus: boolean;
  alert: any;
  email: Email;
  emailType: string;
  successMessage: string;
  errorMessage: string;
  sendMessage: string;
  selectedHour = 12;
  selectedMinute = 30;
  day = 'today';
  time = 'now';
  timeString = '';
  client: any;
  sending = false;

  emailResponse: string;
  emailSuccessfullySend: boolean;
  initializeUrlModal = false;
  private backToMenu$: any;

  @ViewChild('roomNr') roomInput: any;
  @ViewChild('modal') modal: any;
  @ViewChild('modalSend') modalSend: any;
  @ViewChild('emailForm') emailForm: any;
  @ViewChild('urlModal') urlModal: any;

  constructor(
    private route: ActivatedRoute,
    private clientService: ClientService,
    private emailService: EmailService,
    private modalService: ModalService,
    private pagesService: PagesService,
    private translate: TranslateService,
    private utils: UtilsService,
    private router: Router,
    private i18nPipe: I18nPipe,
    private elementRef: ElementRef,
    private renderer: Renderer2
  ) { }

  ngOnInit() {
    this.translate.onLangChange.subscribe(() => {
      this.translate.get('sms.setTime').subscribe(translation => {
        this.timeString = translation;

      });
    });
    this.translate.get('sms.setTime').subscribe(translation => {
      this.timeString = translation;
    });
    this.emailResponse = '';
    this.emailSuccessfullySend = false;
    this.clientService.getClient().subscribe(client => {
      this.client = client;
    });

    const contentId = this.route.snapshot.params['id'];
    this.emailType = this.route.snapshot.params['type'];
    this.pagesService.getPageByID(contentId).subscribe(p => {
      if (p.content && typeof p.content === 'object') {
        for (const locale in p.content) {
          if (typeof p.content[locale] !== 'object') {
            p.content[locale] = p.content[locale].replace(this.utils.getHrefRegex(), 'source=');
          }
        }
      } else if (typeof p.content !== 'undefined' && p.content !== '') {
        p.content = p.content.replace(this.utils.getHrefRegex(), 'source=');
      }

      this.page = p;

      setTimeout(() => {
        const elements = this.elementRef.nativeElement.querySelectorAll('a[source]');
        for (const element of elements) {
          this.renderer.listen(element, 'click', (evt) => {
            this.urlModal.showIframeModal({ '_': element.getAttribute('source') }, 'Title');
          });
        }
        if (elements.length > 0) {
          this.initializeUrlModal = true;
        }
      }, 200);
    });

    this.backToMenu$ = this.modalService.backToMenu$.subscribe(res => {
      this.back();
    });

  }

  /**
	 * selectDay
	 * @param {string} d - A day string
	 * @return {void}
	 */
  selectDay(d: string) {
    this.day = d;
  }

  /**
	 * selectTime
	 * @param {string} time - (optional) A time string
	 * @returns void
	 */
  selectTime(time?: string) {
    if (!time) {
      let minuteString = '' + this.selectedMinute;
      if (this.selectedMinute < 10) {
        minuteString = '0' + this.selectedMinute;
      }
      const t: string = this.selectedHour + ':' + minuteString;
      this.time = t;
      this.timeString = t;
    } else {
      this.time = time;
      this.translate.get('sms.setTime').subscribe(translation => {
        this.timeString = translation;
      });
    }

    this.modal.hide();
  }

  /**
	 * opens the time picker component modal
	 * @return {void}
	 */
  openTimepicker() {
    this.modal.show();
  }

  /**
	 * buildTimeText
	 * returns a text with the selected timeString
	 * @param {string} time - The time to concat
	 * @param {day} day - The day to concat
	 * @return {string} The date-time in textform
	 */
  buildTimeText(time: string, day: string): string {
    let timeText: string;
    let dayText: string;
    if (day === 'tomorrow') {
      dayText = 'morgen';
    } else if (day === 'today') {
      dayText = 'heute';
    } else if (day === 'dayaftertomorrow') {
      dayText = 'übermorgen';
    }
    if (time === 'now' && day === 'today') {
      timeText = 'jetzt';
    } else {
      timeText = dayText + ' um ' + time + 'Uhr';
    }
    return timeText;
  }


  sendEmail(roomNumber: string, personNumber: string) {
    if (roomNumber.trim().length < 1) {
      this.roomNumber = '';
      return false;
    }
    const that = this;
    this.sending = true;
    let personText: string;
    const timeText: string = this.buildTimeText(this.time, this.day);
    if (personNumber === '1') {
      personText = personNumber + ' Gast';
    } else {
      personText = personNumber + ' Gäste';
    }

    const clientTitle = this.i18nPipe.transform(this.client.title, false);
    this.build([personText, roomNumber, clientTitle, timeText]);
    const email = new Email(Number(this.page.id), this.page.emailSubject, this.sendMessage, null);
    if (this.page) {
      this.emailService.sendEmail(email)
        .subscribe(data => {
          this.emailResponse = that.successMessage;
          this.emailSuccessfullySend = true;
          this.modalSend.show();
          this._resetForm();
          this.sending = false;
        }, error => {
          console.warn('Could not send email.');
          console.warn(error);
          this.emailResponse = that.errorMessage;
          this.emailSuccessfullySend = false;
          this.modalSend.show();
          this._resetForm();
          this.sending = false;
        });

    }
  }

  /**
	 * _showAlert
	 * depricated
	 */
  _showAlert(msg: string) {
    const alert = {
      msg: msg
    };
    this.alert = alert;
  }

  /**
	 * _resetForm
	 * reset the formdata
	 * @return {void}
	 */
  _resetForm() {
    this.roomNumber = '';
    this.personNumber = '';
    this.emailForm.form.reset();
  }

  /**
	 * closeAlert
	 * depricated
	 */
  closeAlert() {
    this.alert = null;
  }

  /**
	 * back
	 * return to the main navigation
	 * @return {void}
	 */
  back() {
    this.router.navigate(['/']);
  }

  /**
	 * successAndBack
	 * closes the modal and calls back
	 * @return {void}
	 */
  successAndBack() {
    this.modalSend.hide();
    this.back();
  }

  /**
	 * set the colors styles for the client
	 * @return {void}
	 */
  setHeaderStyle() {
    if (this.client && this.client.colors) {
      const styles = {
        'background-color': this.client.colors.main,
        'color': this.client.colors.fontLight,
        'opacity': 1
      };
      return styles;
    }
    return {};
  }

  build(args: Array<string>) {
    switch (this.emailType) {
      case 'taxi':
        this.successMessage = 'Nachricht erfolgreich gesendet. Ihr Taxi wird Sie gleich abholen.';
        this.errorMessage = 'Es ist ein Fehler aufgetreten. Versuchen Sie es bitte erneut.';
        this.sendMessage = 'Bitte holen Sie ' + args[3] + ' ' + args[0] + ' aus Zimmer ' + args[1] + ' vom ' + args[2] + ' ab.';
        break;
      case 'restaurant':
        this.successMessage = 'Nachricht erfolgreich gesendet. Ein Tisch wird für Sie reserviert.';
        this.errorMessage = 'Es ist ein Fehler aufgetreten. Versuchen Sie es bitte erneut.';
        this.sendMessage = 'Bitte reservieren Sie ' + args[3] + ' einen Tisch für ' + args[0] + '. Zimmer: ' + args[1];
        break;
      case 'shop':
        this.successMessage = 'Nachricht erfolgreich gesendet. Rufen Sie bitte als nächstes den Link';
        this.successMessage += ' in der email auf, um den Checkout zu beenden.';
        this.errorMessage = 'Es ist ein Fehler aufgetreten. Versuchen Sie es bitte erneut.';
        this.sendMessage = 'Beenden Sie den Checkout mit folgendem Link: ' + args[0];
        break;
      default:
        this.successMessage = 'Nachricht erfolgreich gesendet.';
        this.errorMessage = 'Es ist ein Fehler aufgetreten. Versuchen Sie es bitte erneut.';
        this.sendMessage = args.join(' ');
        break;
    }

  }

  keyUp($event) {
    if ($event && $event.path && $event.path[0]) {
      this.roomNumber = $event.path[0].value;
    }
  }

  ngOnDestroy() {
    if (this.backToMenu$) {
      this.backToMenu$.unsubscribe();
    }
  }

}
